<template>
  <section>
    <h3 class="title">External APIs</h3>
    <section class="section">
      <h3 class="subtitle">WorkflowMax API</h3>
      <b-field grouped group-multiline>
        <b-field label="URL" expanded>
          <b-input type="text" v-model="wfmApiUrl"/>
        </b-field>

        <b-field label="API Key" expanded>
          <b-input type="password" v-model="wfmApiKey"/>
        </b-field>

        <b-field label="Account Key" expanded>
          <b-input type="password" v-model="wfmApiAccountKey"/>
        </b-field>
      </b-field>
    </section>

    <section class="section">
      <h3 class="subtitle">KYC API</h3>
      <b-field grouped group-multiline>
        <b-field label="URL" expanded>
          <b-input type="text" v-model="kycApiUrl"/>
        </b-field>

        <b-field label="Login" expanded>
          <b-input type="text" v-model="kycApiLogin"/>
        </b-field>

        <b-field label="Password" expanded>
          <b-input type="password" v-model="kycApiPassword"/>
        </b-field>
      </b-field>
    </section>

    <section class="section">
      <div class="buttons is-right">
        <button class="button is-primary" @click.prevent="saveData">Save</button>
      </div>
    </section>

  </section>
</template>

<script>

export default {
  name: 'ExternalSettings',
  data () {
    return {
      wfmApiUrl: null,
      wfmApiKey: null,
      wfmApiAccountKey: null,
      kycApiUrl: null,
      kycApiLogin: null,
      kycApiPassword: null
    }
  },
  created () {
    this.getData()
  },
  methods: {
    saveData () {
      this.axios.put('/settings', {
        wfmApiUrl: this.wfmApiUrl,
        wfmApiKey: this.wfmApiKey,
        wfmApiAccountKey: this.wfmApiAccountKey,
        kycApiUrl: this.kycApiUrl,
        kycApiLogin: this.kycApiLogin,
        kycApiPassword: this.kycApiPassword
      })
        .then(response => {
          if (response.data) {
            this.$toast.open({
              message: 'Settings saved',
              type: 'is-info'
            })
            // console.log(response.data)
          }
        })
        .catch(error => {
          console.log(error)
          this.$toast.open({
            message: 'Something went wrong while saving settings',
            type: 'is-danger'
          })
        })
    },
    getData () {
      this.axios.get('/settings')
        .then(response => {
          this.wfmApiUrl = response.data.wfm_api_url
          this.wfmApiKey = response.data.wfm_api_key
          this.wfmApiAccountKey = response.data.wfm_api_account_key
          this.kycApiUrl = response.data.kyc_api_url
          this.kycApiLogin = response.data.kyc_api_login
          this.kycApiPassword = response.data.kyc_api_password
        })
        .catch(error => {
          console.log(error)
          this.$toast.open({
            message: 'Something went wrong while getting settings',
            type: 'is-danger'
          })
        })
    }
  }
}
</script>

<style scoped>

.add-user {
  color: var(--main-text-color);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 2em;
}

</style>
